<template>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-col-12">
      <DataTable
        :value="accountHeadLists"
        :paginator="true"
        :rows="10"
        :first="0" :filters="filters"
        class="p-datatable-responsive p-datatable-gridlines"
      >
        <Column header="S.N" >
         <template #body="slotProps">
          {{slotProps.index+1}}
         </template>
        </Column>
        <Column field="natureName" :sortable="true" header="Account Nature" filterMatchMode="contains">
         <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['natureName']" />
        </template>
        </Column>

        <Column field="name" header="Group Name" :sortable="true" filterMatchMode="contains" >
        <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['name']" />
        </template>
        </Column>

        <!-- <Column field="name" header="Account Name" :sortable="true" filterMatchMode="contains" >
        <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['name']" />
        </template>
        </Column> -->

        <Column header="Action" field>
          <template #empty>No record found</template>
          <template #body="slotProps">

            <Button type="button" icon="pi pi-pencil" class="p-button-success p-button-sm"
             @click="editAccountHead(slotProps.data)"/>
            <Button icon="pi pi-trash" class="p-button-danger p-button-sm" v-if="!slotProps.data.systemOnly"  @click="openDialog(slotProps.data.id)"/>
            <Button icon="pi pi-trash" class="p-button-danger p-button-sm" v-else @click="openDialog(slotProps.data.id)" disabled/>
          </template>
        </Column>
      </DataTable>
      </div>
      <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteAccountHead"/>
    </div>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
export default {
  name: 'accountHeadList',
  data() {
    return {
      // message: '',
      show: false,
      dialogShow: false,
      accountId: '',
      loading: false,
      filters: {}
    }
  },
  components: {
    DataTable,
    Column,
    Dialog,
    InputText,
    Button
  },
  computed: {
    accountHeadLists() {
      return this.$store.state.accountHead.accountHeadLists
    }
  },
  mounted() {
    this.accountHeadList()
  },
  methods: {
    async accountHeadList() {
      try {
        this.$emit('loading-started')
        await this.$store.dispatch('loadAccountHeadList')
      } catch (e) {
        // Handle error
      } finally {
        this.$emit('loading-finished')
      }
    },
    async deleteAccountHead(value) {
      if (value.trim() === '') {
        let message = {
          message: 'Delete reason cannot be empty.',
          messageType: 'error'
        }
        this.dialogShow = true
        this.$emit('delete-message', message)
        return
      }
      let deleteRe = {
        accountHeadId: this.accountId,
        deleteReason: value
      }
      try {
        let resp = await this.$store.dispatch('deleteAccountHead', deleteRe)
        if (resp.data.status === 'SUCCESS') {
          let message = {
            message: resp.data.message,
            messageType: 'success'
          }
          this.$emit('delete-message', message)
        } else {
          let message = {
            message: resp.data.message,
            messageType: 'warn'
          }
          this.$emit('delete-message', message)
        }
      } catch (e) {
        let message = {
          message: 'Something went wrong !!!',
          messageType: 'error'
        }
        this.$emit('delete-message', message)
      }

      // this.message = resp.data.message
      this.closeDialog()
    },
    editAccountHead(data) {
      this.$emit('edit-account', data)
    },
    cancel(data) {
      // this.show = false
      this.dialogShow = false
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
      // this.deleteReason = ''
    },
    closeDialog() {
      this.dialogShow = false
      // this.deleteReason = ''
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// accountHeadList.vue?22157654